// Where the GoodWatch Discord bot page and its install link live. /discord/add redirects to Discord's install dialog,
// so the page, the footer, and anything people copy share one short address.
export const DISCORD_BOT_PATH = "/discord"
export const DISCORD_ADD_PATH = "/discord/add"
export const DISCORD_ADD_URL = `https://goodwatch.app${DISCORD_ADD_PATH}`
// Discord's install dialog for the GoodWatch app. It offers "Add to My Apps" and "Add to Server".
export const DISCORD_INSTALL_URL =
	"https://discord.com/oauth2/authorize?client_id=1562971617183797339"

// The first /search preview on the bot page, shared with its 103 image hint.
export const DISCORD_PREVIEW_BACKDROP = "/8Tfys3mDZVp4tNoH2ktm06a0Tau.jpg"
